import React, { createContext, useContext, useEffect, useState } from "react";
import { API_BASE_URL } from "../config/apiBaseUrl";

type AppConfig = {
  productionMode: boolean;
  isLoading: boolean;
};

const AppConfigContext = createContext<AppConfig | undefined>(undefined);

export const AppConfigProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [productionMode, setProductionMode] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/config`);
        const data = await res.json().catch(() => null);
        if (data?.success && typeof data.productionMode === "boolean") {
          setProductionMode(data.productionMode);
        }
      } catch {
        // Default to false on error
      } finally {
        setIsLoading(false);
      }
    };
    fetchConfig();
  }, []);

  const value = { productionMode, isLoading };

  return (
    <AppConfigContext.Provider value={value}>{children}</AppConfigContext.Provider>
  );
};

export const useAppConfig = (): AppConfig => {
  const ctx = useContext(AppConfigContext);
  if (!ctx) throw new Error("useAppConfig must be used within AppConfigProvider");
  return ctx;
};
